import { TabContainer } from "./Tab1";

const Tab5 = () => {
  return (
    <TabContainer>
      <p className="bold">新服宝藏</p>
      <p>
        <span className="bold">活动区服</span>：龙盘紫霄（2010区新服）
      </p>
      <p>
        <span className="bold">活动时间</span>：3月15日开服后-4月15日24：00
      </p>
      <p>
        <span className="bold">参与等级</span>：角色≥135（或已转生）
      </p>
      <p>
        <span className="bold">活动NPC</span>：江湖接引使
      </p>
      <p className="bold">活动内容：</p>
      <p>
        （1）每日，角色每完成1次普通杀手任务，可以额外获得2张纳新·藏宝图（绑定），掉落至背包（击败任务NPC时请务必保证背包存在至少2格空间，否则有可能无法获得奖励），每个角色每日最多通过杀手任务获得20纳新·藏宝图。
      </p>
      <p>
      （2）通过门客声望快速完成杀手任务亦可直接获得纳新·藏宝图。
      </p>
      <p>
      （3）江湖接引使将为各位大侠鉴定藏宝图，大侠可以于江湖接引使处鉴定藏宝图，并使用纳新·罗盘探寻纳新 · 藏宝图的秘密，挖掘宝物。
      </p>
      <p className="bold">活动奖励：</p>
      <p>
        概率获得<span>100W帮会金锭红包</span>
        、剑侠币、玄天锤（不绑定）、星火炭（不绑定）
        、装备令牌碎片（绑定）等奖励
      </p>
    </TabContainer>
  );
};

export default Tab5;
